var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import UAHelper from 'fk-cp-shared/utils/UAHelper';
import { _unsafe_getString } from '@utils/i18n';
import { CHAT_TYPES } from 'helpCenter/HelpV2/constants';
var triggerFAppAction = function (action) {
    window.location.href = "fapp://action?value=" + encodeURIComponent(JSON.stringify(action));
};
function getPlatform() {
    var platform = '';
    if (UAHelper._isMsite()) {
        platform = 'msite';
    }
    else if (UAHelper._isAndroid()) {
        platform = 'android';
    }
    else if (UAHelper._isIOS()) {
        platform = 'ios';
    }
    return platform;
}
// fk-self-serve is opened Native App && Url Params has -> hlExp=true && appName=MINUTES.
// FKUA -> set by fk native app platform;
// Request is coming from FK Minutes App
var isFKMinutesApp = function (query) {
    var _a, _b, _c, _d, _e;
    return ((_b = (_a = navigator) === null || _a === void 0 ? void 0 : _a.userAgent) === null || _b === void 0 ? void 0 : _b.includes('FKUA')) && (((_c = query) === null || _c === void 0 ? void 0 : _c.hlExp) === true || ((_d = query) === null || _d === void 0 ? void 0 : _d.hlExp) === 'true')
        && ((_e = query) === null || _e === void 0 ? void 0 : _e.appName) === 'MINUTES';
};
var usesWebChatNavigation = function (query) {
    return UAHelper._isMsite() || isFKMinutesApp(query);
};
var redirectToChatForParams = function (contextId, params, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.shouldReplace, shouldReplace = _c === void 0 ? false : _c, query = _b.query;
    var _d, _e, _f, _g;
    var chatAction = {
        loginType: 'LOGIN_NOT_REQUIRED',
        originalUrl: '/chat',
        params: params,
        screenType: 'reactView',
        tracking: {},
        type: 'NAVIGATION',
        url: '/chat'
    };
    if (usesWebChatNavigation(query)) {
        (_e = (_d = window) === null || _d === void 0 ? void 0 : _d.localStorage) === null || _e === void 0 ? void 0 : _e.removeItem('v3ChatAction');
        (_g = (_f = window) === null || _f === void 0 ? void 0 : _f.localStorage) === null || _g === void 0 ? void 0 : _g.setItem('v3ChatAction', JSON.stringify(chatAction));
        var url = "/chat?contextId=" + contextId;
        if (shouldReplace) {
            window.location.replace(url);
        }
        else {
            window.location.href = url;
        }
    }
    else {
        if (shouldReplace && chatAction.params) {
            chatAction.params.killCurrentPage = true;
        }
        triggerFAppAction(chatAction);
    }
};
var redirectToChat = function (_a) {
    var context = _a.context, contextId = _a.contextId, chatType = _a.chatType, _b = _a.chatTenant, chatTenant = _b === void 0 ? '' : _b, _c = _a.isLanguageChangeEnabled, isLanguageChangeEnabled = _c === void 0 ? false : _c, restParams = __rest(_a, ["context", "contextId", "chatType", "chatTenant", "isLanguageChangeEnabled"]);
    var params = __assign({ pingContext: JSON.stringify(__assign(__assign({}, context), { contextId: contextId })), pingEntityType: chatType, chatTenant: chatTenant,
        isLanguageChangeEnabled: isLanguageChangeEnabled, isV3Chat: true, bundleName: 'cross', screenName: 'chat', url: '/chat' }, restParams);
    redirectToChatForParams(contextId, params);
};
var redirectToHomePage = function () {
    triggerFAppAction({
        loginType: 'LOGIN_NOT_REQUIRED',
        originalUrl: '/',
        params: {
            valid: true,
            screenName: 'homepage'
        },
        screenType: 'multiWidgetPage',
        tracking: {},
        type: 'NAVIGATION',
        url: '/'
    });
};
var redirectToClpUrl = function (url) {
    if (UAHelper._isMsite()) {
        window.location.href = url;
    }
    else {
        triggerFAppAction({
            loginType: 'LOGIN_NOT_REQUIRED',
            originalUrl: url,
            params: {
                valid: true,
                screenName: 'clp'
            },
            screenType: 'multiWidgetPage',
            tracking: {},
            type: 'NAVIGATION',
            url: url
        });
    }
};
export var redirectToOhcChat = function (src) {
    redirectToChat({
        context: {
            invocation_source: src + "_" + getPlatform(),
            lang: _unsafe_getString('language')
        },
        contextId: '',
        chatType: CHAT_TYPES.OHC
    });
};
export { redirectToHomePage, redirectToClpUrl, triggerFAppAction, redirectToChat, redirectToChatForParams, usesWebChatNavigation };
